import produce from 'immer';
import {
  PARTNER_ACCOUNT_LIST_REQUEST,
  SET_PARTNER_ACCOUNT_LIST,
  SET_TOTAL_COUNT,
  SET_PARTNER_PAGINATION,
  PARTNER_EMAIL_CHECK,
  CREATE_PARTNER,
  REMOVE_PARTNER,
  PARTNER_ACCOUNT_DETAIL,
} from '../../constants/backoffice/partnerConstants';

const initialState = {
  resultCode: 0,
  code: '',
  description: '',
  accountNo: 0,
  email: '',
  appList: [
    {
      packageName: '',
      appTitle: '',
      developer: ''
    }
  ],
  page: 1,
  pageLength: 10,
  totalCount: 0,
  searchString: '',
  partnerList: [],
  response: 0,
  list: [
    {
      accountNo: 0,
      email: ''
    }
  ],
};

const partnerReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case PARTNER_ACCOUNT_LIST_REQUEST:
      break;
    case CREATE_PARTNER:
      break;
    case REMOVE_PARTNER:
      break;
    case PARTNER_EMAIL_CHECK:
      draft.response = action.data;
      break;
    case SET_PARTNER_ACCOUNT_LIST:
      draft.list = action.list;
      break;
    case SET_TOTAL_COUNT:
      draft.totalCount = action.totalCount;
      break;
    case SET_PARTNER_PAGINATION:
      draft.page = action.page;
      draft.totalCount = action.totalCount;
      draft.searchString = action.searchString;
      break;
    case PARTNER_ACCOUNT_DETAIL:
      draft.appList = action.appList;
      break;
    default:
      break;
  }
});

export default partnerReducer;
